/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserChangeNotificationsStatusRequest
 */
export interface RevisdomAPIViewModelsUserChangeNotificationsStatusRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof RevisdomAPIViewModelsUserChangeNotificationsStatusRequest
     */
    notificationIds?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserChangeNotificationsStatusRequest
     */
    isRead?: boolean;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserChangeNotificationsStatusRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsUserChangeNotificationsStatusRequest(value: object): value is RevisdomAPIViewModelsUserChangeNotificationsStatusRequest {
    return true;
}

export function RevisdomAPIViewModelsUserChangeNotificationsStatusRequestFromJSON(json: any): RevisdomAPIViewModelsUserChangeNotificationsStatusRequest {
    return RevisdomAPIViewModelsUserChangeNotificationsStatusRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserChangeNotificationsStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserChangeNotificationsStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationIds': json['notificationIds'] == null ? undefined : json['notificationIds'],
        'isRead': json['isRead'] == null ? undefined : json['isRead'],
    };
}

export function RevisdomAPIViewModelsUserChangeNotificationsStatusRequestToJSON(json: any): RevisdomAPIViewModelsUserChangeNotificationsStatusRequest {
    return RevisdomAPIViewModelsUserChangeNotificationsStatusRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserChangeNotificationsStatusRequestToJSONTyped(value?: RevisdomAPIViewModelsUserChangeNotificationsStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notificationIds': value['notificationIds'],
        'isRead': value['isRead'],
    };
}

